<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="p-0 mx-auto"
                        md="2"
                        :data-img="image.id"
                        @click="select"
                >
                    <v-img
                            :src="image.full_path"
                            :lazy-src="image.full_path"
                            aspect-ratio="1"
                            :key="image.id"
                    >
                        <v-checkbox
                                v-model="image.selected"
                                :data-md5="image.id"
                                :data-id="image.id"
                                color="success"
                                :value="selectedImage.indexOf(image.id) > -1"
                        ></v-checkbox>
                    </v-img>
                    <p class="text-center mr-5">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "brochure",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'بروشورa3',
                    value: 'officer',
                    full_path: require('../../../../public/media/site/office6/بروشورa3.jpg')
                },
                {
                    id: '2',
                    name: 'بروشورa4',
                    value: 'typography',
                    full_path: require('../../../../public/media/site/office6/بروشورa4.jpg')
                },
                {
                    id: '3',
                    name: 'بروشورa5',
                    value: 'typography',
                    full_path: require('../../../../public/media/site/office6/بروشورa5.jpg')
                },
            ],
            count: 1,
        }
    },
    methods: {
        select(e) {
            if (this.selectedImage.length >= this.count) {
                Swal.fire({
                    title: "خطا",
                    text: "شما فقط میتوانید " + this.count + " تصویر انتخاب کنید",
                    type: "error",
                    confirmButtonText: "باشه"
                });
                return false;
            }
            const md5 = $(e.target).parent().parent().find('input').attr('data-md5')
            if (this.selectedImage.includes(md5))
                this.selectedImage.splice(this.selectedImage.indexOf(md5), 1)
            else
                this.selectedImage.push(md5)

        },
    }
}
</script>

<style scoped>

</style>